// Shared z-index counter and minimize-all broadcast for floating windows
let counter = 1300;
export const nextZ = () => ++counter;
export const currentZ = () => counter;

// Registry of minimize callbacks for "minimize all" on click-outside
const minimizeCallbacks = new Set();
export const registerMinimize = (cb) => { minimizeCallbacks.add(cb); return () => minimizeCallbacks.delete(cb); };
export const minimizeAll = () => { minimizeCallbacks.forEach(cb => cb()); };
